import * as React from "react";
const SvgUser01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.965 21c0-1.47-.012-1.977-.128-2.36a2.97 2.97 0 0 0-1.977-1.977c-.383-.116-.89-.128-2.36-.128h-5c-1.47 0-1.977.012-2.36.128a2.97 2.97 0 0 0-1.977 1.977c-.116.383-.128.89-.128 2.36a1.035 1.035 0 0 1-2.07 0c0-1.32-.011-2.21.217-2.962a5.04 5.04 0 0 1 3.356-3.356c.752-.228 1.642-.217 2.962-.217h5c1.32 0 2.21-.011 2.962.217a5.04 5.04 0 0 1 3.356 3.356c.228.752.217 1.642.217 2.962a1.035 1.035 0 0 1-2.07 0m-3.5-13.5a3.465 3.465 0 1 0-6.93 0 3.465 3.465 0 0 0 6.93 0m2.07 0a5.535 5.535 0 1 1-11.07 0 5.535 5.535 0 0 1 11.07 0"
}));
export default SvgUser01;
//# sourceMappingURL=User01.js.map